import { createContext, useContext } from "solid-js";
export const DismissableLayerContext = createContext();
export function useOptionalDismissableLayerContext() {
    return useContext(DismissableLayerContext);
}
